<!-- Sign-up Form Page 4 -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" #f="ngForm" novalidate>

            <!-- Header -->
            <h1 class="mb-3 text-center">Sign Up</h1>
            <p class="text-center no-margin">Choose payment method and complete your registration with us!</p>
            <p class="text-center"><small>$30 + processing fees to those with addresses outside of Nebraska.</small></p>
            <hr>

            <!-- Payment Methods -->
            <div class="mt-5 mb-4 text-center">
                <ngx-paypal class="paypal-buttons" [config]="payPalConfig"></ngx-paypal>
            </div>

            <!-- Login Link-->
            <p class="mb-3 center text-center">Already have an account?
                <a [routerLink]="'/login'">Login</a>
            </p>
        </form>
    </div>
</section>
